import { DateTimeUtils } from '@common/utils/datetimeUtils';
import { HospitalAppStoreContextWrapper } from "@hospital/contexts/HospitalAppStoreContextWrapper";
import { HospitalAppStore } from "@hospital/stores/rootStores";
import { DateTime } from 'luxon';
import React from "react";
export const useHospitalApp = () => React.useContext<HospitalAppStore>(HospitalAppStoreContextWrapper.get());

export function GetHospitalOpenCloseTimeForToday() {
    const hospitalApp = useHospitalApp();
    const hospitalHours = hospitalApp.currentHospital?.hospitalHours;
    const today = DateTime.now();
    const dayOfWeek = DateTimeUtils.getDayOfWeek(today);
    const openTime = hospitalHours && hospitalHours[dayOfWeek].openTime;
    const closeTime = hospitalHours && hospitalHours[dayOfWeek].closeTime;
    return { openTime, closeTime };
}
